import { createRoot } from 'react-dom/client';
import App from './App';
import './design-tokens.css';

createRoot(document.getElementById('root')!).render(<App />);
